<template>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.61 60" class="fill-current">
    <g id="Group_1627" data-name="Group 1627">
      <g id="Group_330" data-name="Group 330">
        <g id="Group_327" data-name="Group 327">
          <g id="Group_326" data-name="Group 326">
            <path class="cls-1" d="M46,.5V38.75H23.16V13.32A8.67,8.67,0,0,1,29.54,5Z"
                  transform="translate(-0.7 -0.5)"/>
            <polygon class="cls-1" points="22.46 40.4 45.33 40.41 45.33 60 22.46 60 22.46 40.4"/>
          </g>
          <polygon class="cls-1"
                   points="16.79 7.78 16.79 34.99 16.41 34.55 13.77 42.37 9.64 20.01 6.99 38.25 0.13 38.25 0 38.37 0 12.33 16.79 7.78"/>
          <polygon class="cls-1"
                   points="16.79 40.19 16.79 59.98 0 59.98 0 40.41 8.86 40.41 9.9 33.3 13.16 50.96 16.79 40.19"/>
        </g>
      </g>
      <g id="Hurst_Review" data-name="Hurst Review" class="cls-2">
        <g class="cls-2">
          <path class="cls-1" d="M65.19,14.65h3.75V21h7.27V14.65H80v17H76.21V24.3H68.94v7.34H65.19Z"
                transform="translate(-0.7 -0.5)"/>
          <path class="cls-1"
                d="M98.34,25.09a8,8,0,0,1-.46,2.78,6,6,0,0,1-1.35,2.21,6.22,6.22,0,0,1-2.25,1.46,9.36,9.36,0,0,1-6.21,0,6.22,6.22,0,0,1-2.25-1.46,6,6,0,0,1-1.35-2.21A8,8,0,0,1,84,25.09V14.65h3.74V24.94A4.13,4.13,0,0,0,88,26.41a3.4,3.4,0,0,0,.7,1.16,3.17,3.17,0,0,0,1.1.77,3.47,3.47,0,0,0,1.38.28,3.37,3.37,0,0,0,1.36-.28,3.09,3.09,0,0,0,1.08-.77,3.42,3.42,0,0,0,.71-1.16,4.13,4.13,0,0,0,.25-1.47V14.65h3.75Z"
                transform="translate(-0.7 -0.5)"/>
          <path class="cls-1"
                d="M102.39,14.65H109a11.53,11.53,0,0,1,2.46.25,5.85,5.85,0,0,1,2,.84,4.18,4.18,0,0,1,1.39,1.58,5.34,5.34,0,0,1,.52,2.49,5,5,0,0,1-.94,3.06,4.17,4.17,0,0,1-2.73,1.59L116,31.64h-4.49L108,24.85h-1.85v6.79h-3.75Zm3.75,7h2.21c.33,0,.69,0,1.06,0a3.18,3.18,0,0,0,1-.21,1.72,1.72,0,0,0,.76-.57,1.69,1.69,0,0,0,.3-1.08,1.64,1.64,0,0,0-.94-1.62,3.17,3.17,0,0,0-.93-.27,7.33,7.33,0,0,0-1-.07h-2.45Z"
                transform="translate(-0.7 -0.5)"/>
          <path class="cls-1"
                d="M127,18.8a2.71,2.71,0,0,0-1.24-.85,4.29,4.29,0,0,0-1.48-.28,3.56,3.56,0,0,0-.84.1,2.93,2.93,0,0,0-.81.3,1.65,1.65,0,0,0-.63.54,1.34,1.34,0,0,0-.24.81,1.36,1.36,0,0,0,.58,1.18,5.76,5.76,0,0,0,1.45.7c.59.19,1.21.38,1.89.57a7.71,7.71,0,0,1,1.88.82A4.44,4.44,0,0,1,129,24.1a4.3,4.3,0,0,1,.58,2.38A5.48,5.48,0,0,1,129,29a4.9,4.9,0,0,1-1.43,1.75,6,6,0,0,1-2.09,1,9.69,9.69,0,0,1-5.58-.17,7.86,7.86,0,0,1-2.64-1.63L119.94,27a3.91,3.91,0,0,0,1.45,1.19,4.14,4.14,0,0,0,1.81.42,4.29,4.29,0,0,0,.93-.11,2.83,2.83,0,0,0,.84-.33,1.86,1.86,0,0,0,.6-.55,1.38,1.38,0,0,0,.22-.79,1.43,1.43,0,0,0-.58-1.21,5.54,5.54,0,0,0-1.48-.76c-.59-.21-1.23-.41-1.92-.62a8.73,8.73,0,0,1-1.92-.84A4.79,4.79,0,0,1,118.41,22a4,4,0,0,1-.58-2.28,5.06,5.06,0,0,1,.54-2.4,5.15,5.15,0,0,1,1.44-1.73,6.32,6.32,0,0,1,2.07-1,8.59,8.59,0,0,1,2.43-.34,9.59,9.59,0,0,1,2.78.4A6.49,6.49,0,0,1,129.51,16Z"
                transform="translate(-0.7 -0.5)"/>
          <path class="cls-1" d="M136.21,18h-4.85V14.65H144.8V18H140V31.64h-3.74Z"
                transform="translate(-0.7 -0.5)"/>
        </g>
        <g class="cls-2">
          <path class="cls-1"
                d="M65.19,40.65h6.58a11.53,11.53,0,0,1,2.46.25,5.85,5.85,0,0,1,2,.84,4.18,4.18,0,0,1,1.39,1.58,5.34,5.34,0,0,1,.52,2.49,5,5,0,0,1-.94,3.06,4.17,4.17,0,0,1-2.73,1.59l4.32,7.18H74.34l-3.55-6.79H68.94v6.79H65.19Zm3.75,7h2.21c.33,0,.69,0,1.06,0a3.18,3.18,0,0,0,1-.21,1.72,1.72,0,0,0,.76-.57,1.69,1.69,0,0,0,.3-1.08,1.64,1.64,0,0,0-.94-1.62,3.17,3.17,0,0,0-.93-.27,7.33,7.33,0,0,0-1-.07H68.94Z"
                transform="translate(-0.7 -0.5)"/>
          <path class="cls-1" d="M81.49,40.65H93V44.1h-7.8v3.17H92.6v3.46H85.23v3.45h8.24v3.46h-12Z"
                transform="translate(-0.7 -0.5)"/>
          <path class="cls-1" d="M95.39,40.65h4.27l4.2,11.13h0l4.27-11.13h4l-7,17h-3Z"
                transform="translate(-0.7 -0.5)"/>
          <path class="cls-1" d="M114.51,40.65h3.75v17h-3.75Z" transform="translate(-0.7 -0.5)"/>
          <path class="cls-1" d="M122.41,40.65H134V44.1h-7.8v3.17h7.37v3.46h-7.37v3.45h8.24v3.46h-12Z"
                transform="translate(-0.7 -0.5)"/>
          <path class="cls-1"
                d="M136.21,40.65h4.08L143,51.54h.05l3.55-10.89h3.48l3.53,11.18h0l2.85-11.18h3.79l-5,17H152l-3.74-11.76h0l-3.75,11.76h-3.21Z"
                transform="translate(-0.7 -0.5)"/>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Logo',
};
</script>

<style scoped>

</style>